export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12945.7f7a5791.jpg";